import { atom } from 'recoil'

export interface IAppConfigAtom {
  loading: boolean
  heightHeader?: number
}

const appConfigAtom = atom<IAppConfigAtom>({
  key: 'appConfigAtom',
  default: {
    loading: false,
  },
})

export default appConfigAtom
